export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5014.053d59fa.jpg";